<template>
  <div class="container-content">
    <component :is="currentView" :ref="currentView"></component>
  </div>
</template>

<script>
/* global Vue:true */
const importCustom = file => require('@/layout/' + file + '.vue').default

export default {
  data () {
    return {
      currentView: ''
    }
  },
  mounted () {
    const _self = this;
    _self.initContent()
  },
  watch: {
    '$route' (to, from) {
      this.initContent()
    }
  },
  computed: {
  },
  methods: {
    initContent () {
      const _self = this
      let path = _self.$route.path
      // 直接读取页面
      if (path.startsWith('/custom/')) {
        let customPath = path.split('/custom/')[1]
        let regularComponent = (customPath || '').replace(/\//g, '_')
        let _component = 'custom' + '_' + regularComponent
        try {
          Vue.component(_component, Vue.extend(importCustom(customPath)))
          _self.currentView = _component
        } catch (e) {
          try {
            Vue.component(_component, Vue.extend(importCustom(customPath + '/index')))
            _self.currentView = _component
          } catch (e) {
            _self.$router.push({path: '/404'})
          }
        }
      } else if (!path.includes('/dashboard') && (path !== '/')) {
        _self.$router.push({path: '/404'})
      }
    }
  }
}
</script>

<style scoped lang="less">
.container-content{
  width: @body-width;
  margin: 0 auto;
  background-color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/layout/home/mainContent.vue